// @flow
/* eslint react/forbid-prop-types:0 */
import * as React from 'react';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import cx from 'classnames';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyLoadingSpinner from 'app/common/react/ui/deprecated/LegacyLoadingSpinner';

type Props = {
  accessibilityLabel?: string,
  children?: React.Node,
  className?: string,
  disabled?: boolean,
  hasIcon?: boolean,
  htmlType?: 'button' | 'submit' | 'reset',
  id?: string,
  itemProp?: string,
  large?: boolean,
  loading?: boolean,
  onClick?: Function,
  onMouseDown?: Function,
  onMouseEnter?: Function,
  onMouseLeave?: Function,
  rel?: string,
  rounded?: 'left' | 'right' | true | false,
  showText?: boolean,
  src?: string,
  stopPropagation?: boolean,
  style?: Object,
  text?: React.Node,
  type?: 'borderless' | 'dim' | 'primary' | 'default' | 'plain',
};

export default class LegacyButton extends React.Component<Props> {
  static defaultProps = {
    disabled: false,
    htmlType: 'button',
    large: false,
    rounded: true,
    showText: true,
    type: 'default',
  };

  handleClick = (e: SyntheticEvent<>) => {
    if (e) {
      e.preventDefault();
    }

    // Do not process button clicks when we are showing a spinner.
    if (this.props.loading) {
      return;
    }

    if (this.props.src) {
      // TODO: use anchor tags for accesibility reasons
      changeWindowLocation(this.props.src);
    } else if (this.props.onClick) {
      this.props.onClick(e);
    }

    if (this.props.stopPropagation) {
      e.stopPropagation();
    }
  };

  render() {
    const {
      accessibilityLabel,
      children,
      disabled,
      hasIcon,
      htmlType,
      id,
      itemProp,
      large,
      loading,
      onMouseDown,
      onMouseEnter,
      onMouseLeave,
      rel,
      rounded,
      showText,
      style,
      text,
      type,
    } = this.props;
    const className = cx(this.props.className, {
      Button: type !== 'plain',
      Module: type !== 'plain',
      btn: type !== 'borderless' && type !== 'plain',
      hasIcon,
      hasText: showText,
      rounded: rounded === true,
      leftRounded: rounded === 'left',
      rightRounded: rounded === 'right',
      borderless: type === 'borderless',
      primary: type === 'primary',
      disabled,
      large,
    });
    return (
      <button
        aria-label={accessibilityLabel || null}
        className={className}
        disabled={disabled}
        id={id}
        itemProp={itemProp}
        onClick={this.handleClick}
        onMouseDown={onMouseDown}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        rel={rel}
        style={style}
        type={htmlType}
      >
        {loading ? <LegacyLoadingSpinner size="small" /> : null}
        {children}
        {hasIcon ? <em /> : null}
        <span className={showText ? 'buttonText' : 'accessibilityText'}>{text}</span>
      </button>
    );
  }
}
